import React, { FC, memo, useEffect, useRef, useState } from "react";
import { TableSessionStatus, UserPlan } from "../constants/enum";
import { colors, queryKeys } from "../constants/constans";
import { useMutation, useQuery, useQueryClient } from "react-query";

import Cookies from "js-cookie";
import CustomNotification from "./CustomNotification";
import ModalConfirm from "./Modal/ModalConfirm";
import { StaffType } from "../types/StaffType";
import { TimeLineType } from "../types/TimeLineType";
import _ from "lodash";
import classNames from "classnames";
import { displayStaffName } from "utils/helper/common";
import { handleErrorMessage } from "../utils/helper/common";
import moment from "moment";
import styles from "./styles.module.scss";
import { updateTableSession } from "../api/tableSession";
import { useCalcEndTime } from "../hooks/useCalcEndTime";
import useDragStaff from "../hooks/useDragStaff";
import useNetworkStatus from "hooks/useNetworkStatus";
import useSetOrderList from "../hooks/useSetOrderList";
import useSetTimeLineInfo from "../hooks/useTimeLineInfo";

export const TimeLineInList: FC<TimeLineType> = (props: TimeLineType) => {
  const {
    startTime,
    intervalTime,
    courseTime,
    timer,
    countNextBtn,
    infoTable,
    setTimelineData,
    cls,
    formListTable,
    activeTableId,
  } = props;

  const { calcNextTime, calcRevisionNextTime } = useCalcEndTime();
  const [timeLineInfo, setTimeLineInfoLocal] = useState<any>([]);
  const { setTimeLineInfo } = useSetTimeLineInfo();
  const { staff, setStaffDrag } = useDragStaff();
  const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
  const blockCurrent = useRef<number>(-1);
  const indexCurrent = useRef<number>(-1);
  const queryClient = useQueryClient();
  const isOnline = useNetworkStatus();
  const firstRender = useRef<boolean>(false);
  const userPlan = Cookies.get("userPlan");

  const updateTableSessionAction = useMutation(updateTableSession);

  const { data: listTimeWorkStaff } = useQuery(
    queryKeys.listTimeWorkStaff
  ) as any;

  //startTime
  const [timeLineData, setTimeLineData] = useState<string[]>([startTime]);

  const oldTimeLineDataRef = useRef<Array<string>>([startTime]); //前回までのTimeLineData

  //前回のタイムラインデータを所得
  let defaultTimeLineData = [...timeLineData];
  let revisionTimeLineData = [...oldTimeLineDataRef.current];

  useEffect(() => {
    const newTimeLineInfo = (infoTable as any)?.timeLineInfo.map(
      (item: any) => {
        const realTimeStart = timeLineData?.findIndex(
          (_, index) => index === item?.block
        );
        if (realTimeStart !== -1) {
          const startTime = timeLineData?.[realTimeStart];
          const endTime = timeLineData?.[realTimeStart + 1];
          return {
            ...item,
            startTime,
            endTime,
          };
        }
      }
    );
    setTimeLineInfoLocal(newTimeLineInfo);
  }, [timeLineData]);

  useEffect(() => {
    setTimeout(() => {
      if ((infoTable as any)?.step === 0 || !!firstRender.current) return;
      firstRender.current = true;
      const table = document.getElementById(`table_${(infoTable as any)?._id}`);
      const widthScroll = Number((infoTable as any)?.step) * 100 + 20;
      if (!table || !(infoTable as any)?.step) return;
      table.scrollLeft += widthScroll;
    }, 1000);
  }, [infoTable]);
  //スタート時間と着席時間、ロスタイムから時間の区切りを作成
  const createTimeLineData = (
    startTime: string,
    intervalTime: number,
    timer: number
  ) => {
    let divisionNum = Math.ceil(
      courseTime / (Number(timer) + Number(intervalTime))
    );
    //初回のみ基本タイムラインデータ作成
    defaultTimeLineData = [startTime];

    for (let i = 0; i < divisionNum + 6; i++) {
      let nextTime = calcNextTime(startTime, intervalTime, timer);
      defaultTimeLineData = [...defaultTimeLineData, nextTime];
      //setTimeLineData((oldValue) => [...oldValue, nextTime]);
      startTime = nextTime;
      // console.log(nextTime);
    }
    oldTimeLineDataRef.current = [...defaultTimeLineData];
    revisionTimeLineData = [...defaultTimeLineData];

    setTimeLineData(defaultTimeLineData);
    if (setTimelineData) {
      setTimelineData(defaultTimeLineData);
    }

    oldTimeLineDataRef.current = [...revisionTimeLineData];
  };

  //--------ここからドラッグされたときの挙動--------//
  const dragStart = (staff: StaffType, block?: number) => {
    if (Number(userPlan) === UserPlan.SubAccount) {
      return;
    }
    if (block && block < (infoTable as any)?.step) {
      return;
    }
    setStaffDrag({
      ...staff,
      isFromTimeLineInList: true,
      isFromTimeLineInListActive: activeTableId === (infoTable as any)?._id,
      tableId: (infoTable as any)?._id,
      infoTable,
      isFromTimeLine: true,
    });
  };

  const dragEnd = (e: React.DragEvent<HTMLDivElement>) => {};

  //ドラッグエリアに入ったらどうするか
  const onDragEnter = (e: React.DragEvent<HTMLDivElement>) => {};

  //ドラッグされた場所で何をするか
  const onDropTineLine = (block: number, index: number) => {
    if (
      !staff?.isFromTimeLineInList &&
      activeTableId !== (infoTable as any)?._id
    )
      return;
    // if (
    //   (activeTableId !== (infoTable as any)?._id &&
    //     staff?.infoTable?._id !== activeTableId) ||
    //   ((infoTable as any)?._id === activeTableId &&
    //     !!staff?.isFromTimeLineInList &&
    //     staff?.infoTable?._id !== activeTableId)
    // ) {
    //   return;
    // }
    if (!!infoTable) {
      if (block < (infoTable as any)?.step) {
        CustomNotification({
          type: "error",
          description: "過去の枠にはスタッフが追加できません",
          message: "",
        });
        return;
      }
    }

    let startTimeOfBlock = moment(startTime, "HH:mm")
      .add((Number(intervalTime) + Number(timer)) * block, "m")
      .format("HH:mm");
    let entTimeOfBlock = moment(startTime, "HH:mm")
      .add((Number(intervalTime) + Number(timer)) * (block + 1), "m")
      .format("HH:mm");

    if (!staff) return;

    const existStaff = timeLineInfo?.find(
      (item: any) =>
        item?.id === staff?.id &&
        staff?.infoTable?._id !== (infoTable as any)?._id
    );
    const existStaffInBlock = timeLineInfo?.find(
      (item: any) =>
        item?.id === staff?.id && item?.block === block && item?.index === index
    );

    const existStaffInIndex = timeLineInfo?.find(
      (item: any) => item?.block === block && item?.index === index
    );

    const changeIndexStaff = staff?.block === block;

    if (!!existStaffInIndex && !changeIndexStaff) {
      CustomNotification({
        type: "error",
        description: "既にスタッフが設定されています。",
        message: "",
      });
      return;
    }

    if (!!existStaffInIndex && changeIndexStaff) {
      const timeLineInfoNew = [] as any[];
      timeLineInfo.forEach((item: any) => {
        if (item?.block === block && item?.index === staff?.index) {
          timeLineInfoNew.push({
            ...item,
            index: existStaffInIndex?.index,
          });
        } else if (
          item?.block === block &&
          item?.index === existStaffInIndex?.index
        ) {
          timeLineInfoNew.push({
            ...item,
            index: staff?.index,
          });
        } else {
          timeLineInfoNew.push({
            ...item,
          });
        }
      });

      setTimeLineInfoLocal([...timeLineInfoNew]);
      if ((infoTable as any)?._id === activeTableId) {
        setTimeLineInfo([...timeLineInfoNew]);
      }

      updateTableSessionAction.mutate(
        {
          id: (infoTable as any)?._id,
          data: {
            ...infoTable,
            timeLineInfo: [...timeLineInfoNew],
          },
        },
        {
          onSuccess: (data) => {
            queryClient.invalidateQueries(queryKeys.listTableSession);
            queryClient.invalidateQueries(queryKeys.listStaffDuplicate);
            queryClient.invalidateQueries(queryKeys.listTimeWorkStaff);
            queryClient.invalidateQueries(queryKeys.staffCount);
          },
          onError: (err) => {
            if (!!isOnline) {
              handleErrorMessage(err);
              return;
            }
            const listTableSessionCurrent = queryClient.getQueryData(
              queryKeys.listTableSession
            ) as any;
            if (Array.isArray(listTableSessionCurrent?.data)) {
              const tableTmp = {
                ...infoTable,
                timeLineInfo,
              };

              const listTableSessionNew = listTableSessionCurrent?.data?.map(
                (item: any) => {
                  if (String(item?._id) === String((infoTable as any)?._id)) {
                    return {
                      ...item,

                      timeLineInfo,
                    };
                  }
                  return item;
                }
              );
              queryClient.setQueryData(queryKeys.listTableSession, {
                data: listTableSessionNew,
              });
            }
          },
        }
      );
      setStaffDrag(null);

      return;
    }

    if (!!existStaffInBlock) {
      return;
    }
    if (!!existStaff) {
      setShowModalConfirm(true);
      blockCurrent.current = block;
      indexCurrent.current = index;
      return;
    }

    // if (!!staff?.isFromTimeLineInList) {
    //   const newTimeLineInfo = staff?.infoTable?.timeLineInfo.filter(
    //     (item: StaffType) =>
    //       !(item?.block === staff.block && item?.index === staff?.index)
    //   );
    //   updateTableSessionAction.mutate(
    //     {
    //       id: (staff?.infoTable as any)?._id,
    //       data: {
    //         ...staff?.infoTable,
    //         timeLineInfo: newTimeLineInfo,
    //       },
    //     },
    //     {}
    //   );
    // }

    const timeLineInfoNew = timeLineInfo?.filter(
      (item: StaffType) =>
        !(
          item.block === staff?.block &&
          item?.index === staff?.index &&
          item?.id === staff?.id
        )
    );
    setTimeLineInfoLocal([
      ...timeLineInfoNew,
      {
        ..._.omit(staff, ["infoTable"]),
        block: block,
        startTime: startTimeOfBlock,
        endTime: entTimeOfBlock,
        index: index, //index start 0 :D, but index in timeline start 1
      },
    ]);
    if ((infoTable as any)?._id === activeTableId) {
      setTimeLineInfo([
        ...timeLineInfoNew,
        {
          ..._.omit(staff, ["infoTable"]),
          block: block,
          startTime: startTimeOfBlock,
          endTime: entTimeOfBlock,
          index: index, //index start 0 :D, but index in timeline start 1
        },
      ]);
    }

    updateTableSessionAction.mutate(
      {
        id: (infoTable as any)?._id,
        data: {
          ...infoTable,
          timeLineInfo: [
            ...timeLineInfoNew,
            {
              ..._.omit(staff, ["infoTable"]),
              block: block,
              startTime: startTimeOfBlock,
              endTime: entTimeOfBlock,
              index: index, //index start 0 :D, but index in timeline start 1
            },
          ],
        },
      },
      {
        onSuccess: (data) => {
          queryClient.invalidateQueries(queryKeys.listTableSession);
          queryClient.invalidateQueries(queryKeys.listStaffDuplicate);
          queryClient.invalidateQueries(queryKeys.listTimeWorkStaff);
          queryClient.invalidateQueries(queryKeys.staffCount);
        },
        onError: (err) => {
          if (!!isOnline) {
            handleErrorMessage(err);
            return;
          }
          const listTableSessionCurrent = queryClient.getQueryData(
            queryKeys.listTableSession
          ) as any;
          if (Array.isArray(listTableSessionCurrent?.data)) {
            const tableTmp = {
              ...infoTable,
              timeLineInfo,
            };

            const listTableSessionNew = listTableSessionCurrent?.data?.map(
              (item: any) => {
                if (String(item?._id) === String((infoTable as any)?._id)) {
                  return {
                    ...item,

                    timeLineInfo,
                  };
                }
                return item;
              }
            );
            queryClient.setQueryData(queryKeys.listTableSession, {
              data: listTableSessionNew,
            });
          }
        },
      }
    );
    setStaffDrag(null);
  };

  const getStaffInBlock = (block: number) => {
    const listStaff = timeLineInfo?.filter(
      (item: any) => item?.block === block
    );
    return listStaff;
  };

  const handleGetBackground = (id: string) => {
    const staffInList = (infoTable as any)?.orderList?.filter(
      (item: any) => String(item?.staff?.id) === String(id)
    );

    const listIndex = staffInList?.map((item: any) => Number(item?.index));

    const colorsOfStaff = colors.filter((_, index) =>
      listIndex?.includes(Number(index))
    );
    if (colorsOfStaff.length < 1) {
      return "";
    }
    if (colorsOfStaff.length === 1) {
      return colorsOfStaff?.[0];
    }

    const colorPercent = 100 / colorsOfStaff.length;

    let result = `linear-gradient(to right,`;

    colorsOfStaff.forEach((color, index) => {
      result += color + " " + colorPercent * index + "%,";
      result += color + " " + colorPercent * (index + 1) + "%";

      if (index !== colorsOfStaff.length - 1) {
        result += ",";
      }
    });
    return result;
  };

  const checkStaffWillDuplicate = (staffId: string, block: number) => {
    if (
      listTimeWorkStaff &&
      listTimeWorkStaff?.data &&
      !Object.keys(listTimeWorkStaff?.data).includes(staffId)
    )
      return;
    const listTimeWork = listTimeWorkStaff?.data[staffId];

    let isDuplicate = false;

    listTimeWork?.forEach((item: any) => {
      if (String(item.infoSession?._id) !== String((infoTable as any)?._id)) {
        const startTimeStringItem = (
          item as any
        )?.infoSession?.timeLineInfoReal?.find(
          (_: any, index: number) => index === item?.block
        );
        const endTimeStringItem = (
          item as any
        )?.infoSession?.timeLineInfoReal?.find(
          (_: any, index: number) => index === item?.block + 1
        );

        const startTime1 = (item as any)?.infoSession?.timeLineInfoReal?.find(
          (_: any, index: number) => index === item?.block
        );
        const startTime2 = (infoTable as any)?.timeLineInfoReal?.find(
          (_: any, index: number) => index === block
        );
        const endTime1 = (item as any)?.infoSession?.timeLineInfoReal?.find(
          (_: any, index: number) => index === item?.block + 1
        );
        const endTime2 = (infoTable as any)?.timeLineInfoReal?.find(
          (_: any, index: number) => index === block + 1
        );

        const combinedTime1 = moment(item?.infoSession?.dateReal).set({
          hour: parseInt(endTime1.split(":")[0], 10),
          minute: parseInt(endTime1.split(":")[1], 10),
          second: 0,
          millisecond: 0,
        });
        const combinedTime2 = moment((infoTable as any)?.dateReal).set({
          hour: parseInt(endTime2.split(":")[0], 10),
          minute: parseInt(endTime2.split(":")[1], 10),
          second: 0,
          millisecond: 0,
        });

        const combinedTime3 = moment(item?.infoSession?.dateReal).set({
          hour: parseInt(startTime1.split(":")[0], 10),
          minute: parseInt(startTime1.split(":")[1], 10),
          second: 0,
          millisecond: 0,
        });
        const combinedTime4 = moment((infoTable as any)?.dateReal).set({
          hour: parseInt(startTime2.split(":")[0], 10),
          minute: parseInt(startTime2.split(":")[1], 10),
          second: 0,
          millisecond: 0,
        });
        if (
          combinedTime1.isBefore(moment(item.infoTable?.startTime, "HH:mm"))
        ) {
          combinedTime1.add(1, "day");
        }

        if (
          combinedTime2.isBefore(
            moment((infoTable as any)?.tableConfig?.startTime, "HH:mm")
          )
        ) {
          combinedTime2.add(1, "day");
        }

        if (
          combinedTime3.isBefore(moment(item.infoTable?.startTime, "HH:mm"))
        ) {
          combinedTime3.add(1, "day");
        }

        if (
          combinedTime4.isBefore(
            moment((infoTable as any)?.tableConfig?.startTime, "HH:mm")
          )
        ) {
          combinedTime4.add(1, "day");
        }

        if (
          (combinedTime1.isBetween(combinedTime4, combinedTime2, null, "()") ||
            combinedTime3.isBetween(combinedTime4, combinedTime2, null, "()") ||
            combinedTime4.isBetween(combinedTime3, combinedTime1, null, "()") ||
            combinedTime2.isBetween(combinedTime3, combinedTime1, null, "()") ||
            (combinedTime4.isSame(combinedTime3) &&
              combinedTime1.isSame(combinedTime2))) &&
          combinedTime2.isAfter(moment()) &&
          combinedTime1.isAfter(moment())
        ) {
          isDuplicate = true;
        }
      }
    });

    return isDuplicate;
  };

  const renderTimeLine = () => {
    //分割の数
    const totalTime =
      Number(courseTime) +
      (Number((infoTable as any)?.totalDifferentTime) || 0) / 60;

    let divisionNum = Math.ceil(
      totalTime / (Number(timer) + Number(intervalTime))
    );

    const totalTIme =
      infoTable && Array.isArray((infoTable as any)?.timeLineInfoReal)
        ? (infoTable as any)?.timeLineInfoReal?.length
        : divisionNum + 6;
    let item = [] as any[];
    for (let i = 0; i < divisionNum; i++) {
      item.push(
        <tr data-timelineindex={i} className={countNextBtn === i ? "now" : ""}>
          <th>{revisionTimeLineData[i]}</th>
          <td>
            <ul>
              {[0, 1, 2, 3].map((item) => {
                return (
                  <div
                    className="blockTimeLine"
                    onDragEnd={dragEnd}
                    onDragEnter={onDragEnter}
                    onDragOver={(e) => {
                      e.preventDefault(); // これがないとdropイベントが発火しない
                    }}
                    onDrop={() => onDropTineLine(i, item)}
                  >
                    {getStaffInBlock(i)
                      ?.filter((staff: any) => staff?.index === item)
                      ?.map((item: any, index: number) => (
                        <li
                          draggable={true}
                          onDragStart={() => dragStart(item, i)}
                          key={index}
                          style={{ background: handleGetBackground(item?.id) }}
                          className={styles.staffTimeLineInList}
                        >
                          <div className="staff">
                            {displayStaffName(item?.staffName)}
                          </div>
                          {checkStaffWillDuplicate(item?.id, i) && (
                            <div className={styles.warningDuplicate}>!</div>
                          )}
                        </li>
                      ))}
                  </div>
                );
              })}
            </ul>
          </td>
        </tr>
      );
    }
    for (let i = divisionNum; i < totalTIme; i++) {
      item.push(
        <tr
          data-timelineindex={i}
          className={countNextBtn === i ? "now white" : "white"}
        >
          <th>{revisionTimeLineData[i]}</th>
          <td>
            <ul>
              {[0, 1, 2, 3].map((item) => {
                return (
                  <div
                    className="blockTimeLine"
                    onDragEnd={dragEnd}
                    onDragEnter={onDragEnter}
                    onDragOver={(e) => {
                      e.preventDefault(); // これがないとdropイベントが発火しない
                    }}
                    onDrop={() => onDropTineLine(i, item)}
                  >
                    {getStaffInBlock(i)
                      ?.filter((staff: any) => staff?.index === item)
                      ?.map((item: any, index: number) => (
                        <li
                          draggable={true}
                          onDragStart={() => dragStart(item, i)}
                          key={index}
                          style={{ background: handleGetBackground(item?.id) }}
                          className={styles.staffTimeLineInList}
                        >
                          <div className="staff">
                            {displayStaffName(item?.staffName)}
                          </div>
                          {checkStaffWillDuplicate(item?.id, i) && (
                            <div className={styles.warningDuplicate}>!</div>
                          )}
                        </li>
                      ))}
                  </div>
                );
              })}
            </ul>
          </td>
        </tr>
      );
    }
    return item;
  };

  useEffect(() => {
    if (!!infoTable) {
      setTimeLineData((infoTable as any)?.timeLineInfoReal);
      revisionTimeLineData = [...(infoTable as any)?.timeLineInfoReal];
      oldTimeLineDataRef.current = [...(infoTable as any)?.timeLineInfoReal];
    } else {
      createTimeLineData(startTime, intervalTime, timer);
    }
  }, [courseTime, timer, countNextBtn, intervalTime, infoTable]);

  useEffect(() => {
    if (!infoTable) {
      setTimeLineInfoLocal([]);
    }
  }, [infoTable]);

  useEffect(() => {
    if (startTime !== (infoTable as any)?.tableConfig?.startTime) {
      createTimeLineData(startTime, intervalTime, timer);
    }
  }, [startTime]);

  const handleCloseModalConfirm = () => {
    setShowModalConfirm(false);
  };

  const handleAddStaffDuplicate = () => {
    let startTimeOfBlock = moment(startTime, "HH:mm")
      .add((Number(intervalTime) + Number(timer)) * blockCurrent.current, "m")
      .format("HH:mm");
    let entTimeOfBlock = moment(startTime, "HH:mm")
      .add(
        (Number(intervalTime) + Number(timer)) * (blockCurrent.current + 1),
        "m"
      )
      .format("HH:mm");

    const timeLineInfoNew = timeLineInfo?.filter(
      (item: StaffType) =>
        !(
          item.block === staff?.block &&
          item?.index === staff?.index &&
          item?.id === staff?.id
        )
    );

    if ((infoTable as any)?._id === activeTableId) {
      setTimeLineInfo([
        ...timeLineInfoNew,
        {
          ..._.omit(staff, ["infoTable"]),
          block: blockCurrent.current,
          startTime: startTimeOfBlock,
          endTime: entTimeOfBlock,
          index: indexCurrent.current, //index start 0 :D, but index in timeline
        },
      ]);
    }
    // if (!!staff?.isFromTimeLineInList) {
    //   const newTimeLineInfo = staff?.infoTable?.timeLineInfo.filter(
    //     (item: StaffType) =>
    //       !(item?.block === staff.block && item?.index === staff?.index)
    //   );
    //   updateTableSessionAction.mutate(
    //     {
    //       id: (staff?.infoTable as any)?._id,
    //       data: {
    //         ...staff?.infoTable,
    //         timeLineInfo: newTimeLineInfo,
    //       },
    //     },
    //     {}
    //   );
    // }
    updateTableSessionAction.mutate(
      {
        id: (infoTable as any)?._id,
        data: {
          ...infoTable,
          timeLineInfo: [
            ...timeLineInfoNew,
            {
              ..._.omit(staff, ["infoTable"]),
              block: blockCurrent.current,
              startTime: startTimeOfBlock,
              endTime: entTimeOfBlock,
              index: indexCurrent.current,
            },
          ],
        },
      },
      {
        onSuccess: (data) => {
          queryClient.invalidateQueries(queryKeys.listTableSession);
          queryClient.invalidateQueries(queryKeys.listStaffDuplicate);
          queryClient.invalidateQueries(queryKeys.listTimeWorkStaff);
          queryClient.invalidateQueries(queryKeys.staffCount);
        },
        onError: (err) => {
          if (!!isOnline) {
            handleErrorMessage(err);
            return;
          }
          const listTableSessionCurrent = queryClient.getQueryData(
            queryKeys.listTableSession
          ) as any;
          if (Array.isArray(listTableSessionCurrent?.data)) {
            const tableTmp = {
              ...infoTable,
              timeLineInfo,
            };

            const listTableSessionNew = listTableSessionCurrent?.data?.map(
              (item: any) => {
                if (String(item?._id) === String((infoTable as any)?._id)) {
                  return {
                    ...item,

                    timeLineInfo,
                  };
                }
                return item;
              }
            );
            queryClient.setQueryData(queryKeys.listTableSession, {
              data: listTableSessionNew,
            });
          }
        },
      }
    );
    setStaffDrag(null);
    setShowModalConfirm(false);
  };
  return (
    <>
      <ModalConfirm
        title="既にスタッフは追加されていますが追加しますか？"
        textCancel={"いいえ"}
        textOke={"はい"}
        header="確認"
        isVisible={showModalConfirm}
        closeIcon={false}
        handleOke={handleAddStaffDuplicate}
        handleCancel={handleCloseModalConfirm}
        handleClose={handleCloseModalConfirm}
      />
      <div
        className={classNames("timeLine", { [cls]: !!cls })}
        id={`table_${(infoTable as any)?._id}`}
      >
        <div className="indexTimeline">
          <div>4</div>
          <div>3</div>
          <div>2</div>
          <div>1</div>
        </div>
        <table>
          <tbody>{renderTimeLine()}</tbody>
        </table>
      </div>
    </>
  );
};
